"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.METADATA_AUTO_REFUND = exports.Criticality = exports.ResolutionType = exports.QualityIssueReason = exports.PostDeliveryPositiveFeedbackItem = exports.PostDeliveryNegativeFeedbackItem = void 0;
var PostDeliveryNegativeFeedbackItem;
(function (PostDeliveryNegativeFeedbackItem) {
    PostDeliveryNegativeFeedbackItem["MissingItems"] = "MissingItems";
    PostDeliveryNegativeFeedbackItem["WrongItems"] = "WrongItems";
    PostDeliveryNegativeFeedbackItem["QualityIssue"] = "QualityIssue";
    PostDeliveryNegativeFeedbackItem["DeliveryTookTooLong"] = "DeliveryTookTooLong";
    PostDeliveryNegativeFeedbackItem["OrderNotDelivered"] = "OrderNotDelivered";
    PostDeliveryNegativeFeedbackItem["DifferentIssue"] = "DifferentIssue";
})(PostDeliveryNegativeFeedbackItem = exports.PostDeliveryNegativeFeedbackItem || (exports.PostDeliveryNegativeFeedbackItem = {}));
var PostDeliveryPositiveFeedbackItem;
(function (PostDeliveryPositiveFeedbackItem) {
    PostDeliveryPositiveFeedbackItem["DeliveredWithCare"] = "DeliveredWithCare";
    PostDeliveryPositiveFeedbackItem["FriendlyService"] = "FriendlyService";
    PostDeliveryPositiveFeedbackItem["FastDelivery"] = "FastDelivery";
    PostDeliveryPositiveFeedbackItem["SomethingElseToSay"] = "SomethingElseToSay";
})(PostDeliveryPositiveFeedbackItem = exports.PostDeliveryPositiveFeedbackItem || (exports.PostDeliveryPositiveFeedbackItem = {}));
var QualityIssueReason;
(function (QualityIssueReason) {
    QualityIssueReason["Damaged"] = "Damaged";
    QualityIssueReason["Expired"] = "Expired";
    QualityIssueReason["PoorQuality"] = "PoorQuality";
})(QualityIssueReason = exports.QualityIssueReason || (exports.QualityIssueReason = {}));
var ResolutionType;
(function (ResolutionType) {
    ResolutionType["Refund"] = "Refund";
    ResolutionType["CustomerSupport"] = "CustomerSupport";
})(ResolutionType = exports.ResolutionType || (exports.ResolutionType = {}));
var Criticality;
(function (Criticality) {
    Criticality["Normal"] = "Normal";
    Criticality["Urgent"] = "Urgent";
})(Criticality = exports.Criticality || (exports.Criticality = {}));
exports.METADATA_AUTO_REFUND = "AUTO_REFUND";
